import React, { Suspense } from 'react';
import { ErrorBoundary } from '@trello/error-reporting';
import { useLazyComponent } from '@trello/use-lazy-component';
import type { BoardClosedProps } from './BoardClosed';

export function LazyBoardClosed(props: BoardClosedProps) {
  const BoardClosed = useLazyComponent(
    () => import(/* webpackChunkName: "board-closed" */ './BoardClosed'),
    {
      preload: false,
      namedImport: 'BoardClosed',
    },
  );

  return (
    <Suspense fallback={null}>
      <ErrorBoundary
        tags={{
          ownershipArea: 'trello-mocha',
          feature: 'Board Closed',
        }}
      >
        <BoardClosed {...props} />
      </ErrorBoundary>
    </Suspense>
  );
}
